export const CATHOLIC_GUY = 'catholicGuy'
export const WATCHING = 'watching'
